import axios from "axios";

export class SuperSpaceService {
  async setSpaces(data): Promise<any> {
    return await axios.post("api/spaces", data);
  }
  async getSuperSpaces(
    name: string,
    pagination: boolean,
    page: number
  ): Promise<any> {
    return await axios.get(
      `api/super_spaces?${pagination ? "page=" + page : "pagination=false"}${
        name ? "&name=" + name : ""
      }`
    );
  }
  async updateSuperSpace(superSpaceId: number, data: any): Promise<any> {
    return await axios.put(`api/super_spaces/${superSpaceId}`, data);
  }
  async getSuperSpaceById(superSpaceId: number): Promise<any> {
    return await axios.get(`api/super_spaces/${superSpaceId}`);
  }
  async uploadSuperSpaceFile(data): Promise<any> {
    return await axios.post(`api/super_space_files`, data);
  }
  async addFavourite(id: number, data): Promise<any> {
    return await axios.post(`api/super_spaces/${id}/add_to_favourites`, data);
  }
  async getSuperSpaceUsersInMultiWebinar(
    superSpaceId: number,
    page: number,
    search: string
  ): Promise<any> {
    return await axios.get(
      `api/super_space_users/super_space/${superSpaceId}/users_connected_to_multi_webinar?page=${page}${search}`
    );
  }
  async getNumberOfUsersInMultiWebinar(superSpaceId: number) {
    return await axios.get(
      `api/super_space_users/super_space/${superSpaceId}/users_connected_to_multi_webinar_counter`
    );
  }
  async changeSuperSpaceWebinarMode(superSpaceId: number, data): Promise<any> {
    return await axios.put(
      `/api/super_spaces/${superSpaceId}/change_webinar_mode`,
      data
    );
  }
  async updateDiary(superSpaceId: number, data): Promise<any> {
    return await axios.put(`/api/super_spaces/${superSpaceId}/diary`, data);
  }
  async getDiary(superSpaceId: number): Promise<any> {
    return await axios.get(`/api/super_spaces/${superSpaceId}/diary`);
  }
  async getSuperSpacesById(superSpaceId: number): Promise<any> {
    return await axios.get(`/api/super_spaces/${superSpaceId}`);
  }
  async updateSuperSpaces(superSpaceId: number, data): Promise<any> {
    return await axios.put(`/api/super_spaces/${superSpaceId}`, data);
  }
  async getSuperSpaceTag(superSpaceId: number, filter: string): Promise<any> {
    //filter-LEARNING|EXPERIENCE|PROJECTS
    if (filter)
      return await axios.get(`/api/super_spaces/${superSpaceId}/tags?type=${filter}`);
    else
      return await axios.get(`/api/super_spaces/${superSpaceId}/tags`);
  } 
  async removeImageSuperSpace(imageId: number) {
    return await axios.delete(`/api/super_space_files/${imageId}`);
  }
  async getPhysicalPlantAndRooms(superSpaceId: number) {
    return await axios.get(`/api/offices/super_space/${superSpaceId}/floors`);
  }
  async createPhysicalPlant(superSpaceId: number, data: any) {
    return await axios.post(`/api/offices/super_space/${superSpaceId}/floor`, data);
  }
  async createPhysicalRoom(plantId: number, data: any) {
    return await axios.post(`/api/offices/floor/${plantId}/room`, data);
  }
  async createPhysicalImage(plantId: number, data): Promise<any> {
    return await axios.post(`api/offices/floor/${plantId}/upload_file`, data);
  }
  async editPhysicalPlant(plantId: number, data: any) {
    return await axios.put(`/api/offices/floor/${plantId}`, data);
  }
  async removePhysicalPlant(plantId: number) {
    return await axios.delete(`/api/offices/floor/${plantId}`);
  }
  async removePhysicalRoom(roomId: number) {
    return await axios.delete(`/api/offices/room/${roomId}`);
  }
  async editPhysicalRoom(roomId: number, data: any) {
    return await axios.put(`/api/offices/room/${roomId}`, data);
  }
  async setSpaceDefault(superSpaceId: number, spaceId: number,) {
    return await axios.post(`/api/super_spaces/${superSpaceId}/space/${spaceId}/set_default`, {});
  }
  async setFeaturePlan(superSpaceId: number, data: any) {
    return await axios.put(`/api/super_spaces/${superSpaceId}/feature_plan`, data);
  }
}
